export const GET_TRIAL_LIST_DATA = 'GET_TRIAL_LIST_DATA'
export const SET_TRIAL_LIST_LOADING = 'SET_TRIAL_LIST_LOADING'
export const GET_TRIAL_CRITERIA_DATA = 'GET_TRIAL_CRITERIA_DATA '
export const SET_TRIAL_CRITERIA_LOADING = 'SET_TRIAL_CRITERIA_LOADING'
export const SET_CURRENT_TRIAL = 'SET_CURRENT_TRIAL'
export const CLEAR_TRIAL = 'CLEAR_TRIAL'
